import { ColDef } from 'ag-grid-community';

type SetColumnDefinitionsFieldParam = { fieldName: string, value: any, applyTo?: string };

const setColumnDefinitionsSingleField = ({
  fieldName,
  value,
  applyTo,
}: SetColumnDefinitionsFieldParam) => (colDefs: ColDef[]) =>
  colDefs.map(colDef => {
    if (!applyTo || colDef.field === applyTo) {
      return {
        ...colDef,
        [fieldName]: value,
      };
    }
    return colDef;
  });


export const setColumnDefinitionsField = (params: SetColumnDefinitionsFieldParam[]) => (colDefs: ColDef[]) =>
  params.reduce<ColDef[]>(
    (accu, params) => setColumnDefinitionsSingleField(params)(accu),
    colDefs
  );

export const mergeColumnDefinitionsField = (fields: string[], colDefToMerge: Partial<ColDef>) => (colDefs: ColDef[]) =>
  colDefs.map(colDef => (
    colDef.field && fields.includes(colDef.field)
      ? ({
        ...colDef,
        ...colDefToMerge,
      })
      : colDef
  ));
